import "C:/GitHub/ChFl_website/src/static/index/modulePageAnimSetup.js";